<template>
  <div v-bind:class="{error}">
    <label class="label" v-if="props.type !== 'checkbox'">
      {{ labelText }}
      <span
        v-if="'labelinfo' in props && props.labelinfo" 
        class="label-info"
      >
        <span class="label-info__icon">i</span>
      </span>
      <span class="label-text">{{ props.labelinfo }}</span>
    </label>
    <input
      v-if="props.type == 'text' || props.type == 'number' || props.type == 'email' || props.type == 'date'" 
      :readonly="'readonly' in props && props.readonly"
      class="input"
      v-bind:class="{'input--readonly': 'readonly' in props && props.readonly}"
      :type="props.type"
      :placeholder="props.placeholder"
      v-model="model"
    >
    <input
      :readonly="'readonly' in props && props.readonly"
      class="input"
      v-bind:class="{'input--readonly': 'readonly' in props && props.readonly}"
      v-else-if="props.type == 'phone'"
      v-model="model" 
      placeholder="+7(999) 999-99-99"
      v-mask="'+7(###) ###-##-##'"
      maskChar=" "
    ></input>
    <template  v-else-if="props.type == 'checkbox'">
      <label class="label">
        <input
          :readonly="'readonly' in props && props.readonly"
          class="input"
          v-bind:class="{'input--readonly': 'readonly' in props && props.readonly}"
          v-model="model" 
          :type="props.type"
        ></input> {{ labelText }}
      </label>
    </template>
    <select 
      v-bind:class="{'input--readonly': 'readonly' in props && props.readonly}"
      :readonly="'readonly' in props && props.readonly"
      v-else
      class="input"
      v-model="model"
    >
      <option
        v-for="(value, key) in listValues"
        v-bind:key="key"
      >{{ value }}</option>
    </select>
  </div>
</template>

<script setup>
import { ref, defineModel, defineProps, defineEmits, computed, watch, onMounted } from 'vue';

const labelText = computed(() => {
  if('notrequired' in props && props.notrequired) return props.label.replace('*', '');
  return props.label;
});
const listValues = computed(() => {
  //console.log('values^');
  //console.log(props.listvalues);
  if('listvalues' in props) return props.listvalues;
  return [];
});
const error = ref(false);
const model = defineModel();

const emit = defineEmits(['input']);
const props = defineProps([
  'name', 
  'type', 
  'label', 
  'listvalues', 
  'mask', 
  'placeholder', 
  'labelinfo', 
  'notrequired', 
  'dinamic',
  'readonly'
]);

function testPattern(pattern, value) {
  return pattern.test(value);
}
function input() {
  console.log(model.value);

  if(props.notrequired) {
    error.value = false;
  } else if(props.mask && props.mask.length) {
    const pattern = new RegExp(props.mask, 'gi');
    const incorrectValue = !testPattern(pattern, model.value);
    error.value = incorrectValue;
  } else if(!model.value || model.value == 'undefined-undefined-') {
    error.value = true;
  } else if(props.type == 'date' && dateIsOld()) {
    error.value = true;
  } else {
    error.value = false;
  }

  if(error.value) {
    emit('input', props.name, null);
  } else {
    emit('input', props.name, model.value);
  }
}

/**
 * Все даты должны быть после октября 1917 и до сегодняшнего времени!
 * Если нет- дата считается устаревшей
 */
function dateIsOld() {
  const dtMay = new Date();
  dtMay.setFullYear(1917);
  dtMay.setMonth(10);
  dtMay.setDate(7);

  const curDate = new Date();
  const dtArr = model.value.split('-');
  curDate.setFullYear(dtArr[0]);
  curDate.setMonth(dtArr[1]);
  curDate.setDate(dtArr[2]);

  console.log(curDate < new Date());

  return (dtMay > curDate) && (curDate < new Date()); 
}

watch(() => props.notrequired, val => {
  input();
});
watch(() => props.dinamic, val => {
  input();
});
watch(model, val => {
  input();
});
onMounted(() => {
  input();
});
</script>

<style lang="scss">
.input{
  display: block;
  width: 100%;
  border: 1px solid #888;
  border-radius: 10px;
  line-height: 1.5em;
  padding: 10px 15px;
  box-sizing: border-box;
  color: #000;
  outline: none;

  &--readonly{
    background-color: rgba(0,0,0,0.15);
  }
  &[type='checkbox']{
    display: inline-block;
    width: auto;
  }
}
.label{
  color: #000;
  font-size: 0.8em;
  font-weight: bold;
  display: block;
  margin-bottom: 0.5em;
}
.error{
  .label{
    color: #f33;
  }
  .input{
    border-color: #f33;
  }
}
.label-info{
  display: inline-block;
  margin-left: 1em;
  position: relative;
  overflow: visible;

  &__icon{
    display: inline-block;
    width: 1.2em;
    height: 1.2em;
    color: #999;
    border: 1px solid #999;
    border-radius: 1.2em;
    text-align: center;
  }
  &:hover+.label-text{
    display: block;
  }
}
.label-text{
  position: absolute;
  display: none;
  top: 2em;
  left: 0;
  width: 150px;
  min-width: 150px;
  padding: 1em;
  background-color: #fff;
  border: 1px solid #999;
  color: #999;
  border-radius: 1em;
  z-index: 1;
  
}
</style>